import type { Router } from 'vue-router';

const routedPathPrefixes = ['/products/', '/collections/', '/pages/'] as const;

const isRoutablePath = (pathname: string): boolean =>
  routedPathPrefixes.some((prefix) => pathname.startsWith(prefix));

export const interceptInternalLinks = (router: Router): void => {
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const eventTarget = event.target;
    if (!(eventTarget instanceof Element)) return;

    const anchor = eventTarget.closest('a');
    if (!anchor || anchor.target || anchor.hasAttribute('download')) return;
    if (anchor.rel.includes('external') || anchor.hasAttribute('data-external')) return;

    const href = anchor.getAttribute('href');
    if (!href || href.startsWith('#')) return;

    const url = new URL(href, window.location.origin);
    if (url.origin !== window.location.origin || !isRoutablePath(url.pathname)) return;

    event.preventDefault();
    router.push(`${url.pathname}${url.search}${url.hash}`);
  });
};
